// hooks/useOnboardingFacade.js
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserProfile } from '../Actions/user';

export const useOnboardingFacade = (user) => {

  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    role: user?.role || '', // 'student' | 'professional' | 'explorer'
    fullName: user?.name || 'Explorer',
    profileImage: user?.profileImage || null,
    collegeName: user?.collegeName || '',
    branch: user?.branch || '',
    graduationYear: user?.graduationYear || '',
    isCollegeVerified: false
  });

  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.userProfile) || {};

  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const handleSignOut = () => {
    localStorage.clear();
    window.location.reload();
  }

  const handleFinish = async () => {
    try {
      const payload = {
        role: formData.role, // 'student' | 'pro' | 'explorer'
        collegeName: formData.collegeName,
        branch: formData.branch,
        graduationYear: formData.graduationYear,
        onboardingCompleted: true, // Simple boolean as discussed
        isCollegeVerified: false  // Default for later use
      };

      // Replace with your actual API endpoint
      await dispatch(updateUserProfile(payload));
      setStep(4);
      //window.location.href = '/dashboard';
    } catch (err) {
      console.error("Onboarding submission failed", err);
      setStep(2);
    }
  };

  return {
    step,
    formData,
    setFormData,
    nextStep,
    prevStep,
    handleFinish,
    loading,
    handleSignOut
  };
};